// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"9107eaed","455":"fa23daeb","580":"373d96a3","838":"ecb620b1"}[chunkId] + ".chunk.css";
};